module.exports = __webpack_public_path__ + "img/main-logo.c67e5b54.png";